export default __webpack_public_path__ + "static/ssm_01-791335a1f0506bd4af474985d3997e78.png";